// extracted by mini-css-extract-plugin
module.exports = {"title":"Header-module--title--3CV6c","label":"Header-module--label--U2STy","contact":"Header-module--contact--3m6gW","languages":"Header-module--languages--1ph6J"};